/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Version } from './Version';
import {
    VersionFromJSON,
    VersionFromJSONTyped,
    VersionToJSON,
    VersionToJSONTyped,
} from './Version';

/**
 * 
 * @export
 * @interface CurrentArtifactVersions
 */
export interface CurrentArtifactVersions {
    /**
     * 
     * @type {Version}
     * @memberof CurrentArtifactVersions
     */
    version: Version;
    /**
     * Hex-encoded SHA-512 hash of the APK.
     * @type {string}
     * @memberof CurrentArtifactVersions
     */
    appApkHash: string;
    /**
     * Hex-encoded SHA-512 hash of the `ELOoperator` APK.
     * @type {string}
     * @memberof CurrentArtifactVersions
     */
    elooperatorApkHash: string;
    /**
     * Hex-encoded SHA-512 hash of the `ELOservice` APK.
     * @type {string}
     * @memberof CurrentArtifactVersions
     */
    eloserviceApkHash: string;
    /**
     * Hex-encoded SHA-512 hash of the vehicle device firmware image.
     * @type {string}
     * @memberof CurrentArtifactVersions
     */
    vehicleDeviceFirmwareHash: string;
    /**
     * Hex-encoded SHA-512 hash of the motion sensor firmware image.
     * @type {string}
     * @memberof CurrentArtifactVersions
     */
    motionSensorFirmwareHash: string;
}

/**
 * Check if a given object implements the CurrentArtifactVersions interface.
 */
export function instanceOfCurrentArtifactVersions(value: object): value is CurrentArtifactVersions {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('appApkHash' in value) || value['appApkHash'] === undefined) return false;
    if (!('elooperatorApkHash' in value) || value['elooperatorApkHash'] === undefined) return false;
    if (!('eloserviceApkHash' in value) || value['eloserviceApkHash'] === undefined) return false;
    if (!('vehicleDeviceFirmwareHash' in value) || value['vehicleDeviceFirmwareHash'] === undefined) return false;
    if (!('motionSensorFirmwareHash' in value) || value['motionSensorFirmwareHash'] === undefined) return false;
    return true;
}

export function CurrentArtifactVersionsFromJSON(json: any): CurrentArtifactVersions {
    return CurrentArtifactVersionsFromJSONTyped(json, false);
}

export function CurrentArtifactVersionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentArtifactVersions {
    if (json == null) {
        return json;
    }
    return {
        
        'version': VersionFromJSON(json['version']),
        'appApkHash': json['appApkHash'],
        'elooperatorApkHash': json['elooperatorApkHash'],
        'eloserviceApkHash': json['eloserviceApkHash'],
        'vehicleDeviceFirmwareHash': json['vehicleDeviceFirmwareHash'],
        'motionSensorFirmwareHash': json['motionSensorFirmwareHash'],
    };
}

export function CurrentArtifactVersionsToJSON(json: any): CurrentArtifactVersions {
    return CurrentArtifactVersionsToJSONTyped(json, false);
}

export function CurrentArtifactVersionsToJSONTyped(value?: CurrentArtifactVersions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': VersionToJSON(value['version']),
        'appApkHash': value['appApkHash'],
        'elooperatorApkHash': value['elooperatorApkHash'],
        'eloserviceApkHash': value['eloserviceApkHash'],
        'vehicleDeviceFirmwareHash': value['vehicleDeviceFirmwareHash'],
        'motionSensorFirmwareHash': value['motionSensorFirmwareHash'],
    };
}

